import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, renderSlot as _renderSlot, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = (n) => (_pushScopeId("data-v-07700876"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    id: "hit-header",
    class: "bg-header"
};
const _hoisted_2 = { class: "flex items-center justify-between w-full" };
const _hoisted_3 = {
    key: 0,
    class: "icon-wrapper flex items-center justify-center logo-style"
};
const _hoisted_4 = {
    id: "svg1",
    class: "logo-color",
    width: "50.963001mm",
    height: "50.963001mm",
    viewBox: "0 0 50.963002 50.963001",
    version: "1.1",
    "inkscape:version": "1.4 (e7c3feb100, 2024-10-09)",
    "sodipodi:docname": "hit-online-avatar-black.svg",
    "xmlns:inkscape": "http://www.inkscape.org/namespaces/inkscape",
    "xmlns:sodipodi": "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:svg": "http://www.w3.org/2000/svg"
};
const _hoisted_5 = /*#__PURE__*/ _createStaticVNode("<defs id=\"defs1\" data-v-07700876><clipPath id=\"clipPath14\" clipPathUnits=\"userSpaceOnUse\" data-v-07700876><path id=\"path14\" d=\"M 0,841.89 H 1190.551 V 0 H 0 Z\" transform=\"translate(-618.87962,-493.17621)\" data-v-07700876></path></clipPath><clipPath id=\"clipPath16\" clipPathUnits=\"userSpaceOnUse\" data-v-07700876><path id=\"path16\" d=\"M 0,841.89 H 1190.551 V 0 H 0 Z\" transform=\"translate(-563.16564,-420.94411)\" data-v-07700876></path></clipPath><clipPath id=\"clipPath18\" clipPathUnits=\"userSpaceOnUse\" data-v-07700876><path id=\"path18\" d=\"M 0,841.89 H 1190.551 V 0 H 0 Z\" transform=\"translate(-611.92082,-431.68201)\" data-v-07700876></path></clipPath><clipPath id=\"clipPath20\" clipPathUnits=\"userSpaceOnUse\" data-v-07700876><path id=\"path20\" d=\"M 0,841.89 H 1190.551 V 0 H 0 Z\" transform=\"translate(-730.97102,-420.94491)\" data-v-07700876></path></clipPath></defs>", 1);
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("g", {
    id: "layer1",
    "inkscape:label": "Layer 1",
    "inkscape:groupmode": "layer",
    transform: "translate(-36.160304,-27.436081)"
}, [
    /*#__PURE__*/ _createElementVNode("g", {
        id: "g1",
        transform: "translate(4.2464003)"
    }, [
        /*#__PURE__*/ _createElementVNode("path", {
            id: "path13",
            d: "m 0,0 h -2.667 c -2.37,0 -4.292,-1.922 -4.292,-4.292 v -40.531 c 9.254,-5.642 15.466,-15.801 15.466,-27.409 0,-11.609 -6.212,-21.766 -15.466,-27.408 v -40.531 c 0,-2.37 1.922,-4.292 4.292,-4.292 h 34.965 c 2.37,0 4.292,1.922 4.292,4.292 V -36.59 C 36.59,-16.382 20.208,0 0,0",
            style: { "fill-opacity": "1", "fill-rule": "nonzero", "stroke": "none" },
            transform: "matrix(0.35277776,0,0,-0.35277776,65.722366,27.436081)",
            "clip-path": "url(#clipPath14)"
        }),
        /*#__PURE__*/ _createElementVNode("path", {
            id: "path15",
            d: "M 0,0 C 0,11.606 6.209,21.762 15.459,27.405 V 67.94 c 0,2.371 -1.922,4.292 -4.292,4.292 h -34.959 c -2.37,0 -4.292,-1.921 -4.292,-4.292 v -96.626 c 0,-22.419 16.942,-40.882 38.722,-43.281 2.561,-0.282 4.821,1.715 4.821,4.292 v 40.272 C 6.209,-21.761 0,-11.605 0,0",
            style: { "fill-opacity": "1", "fill-rule": "nonzero", "stroke": "none" },
            transform: "matrix(0.35277776,0,0,-0.35277776,46.067715,52.959801)",
            "clip-path": "url(#clipPath16)"
        }),
        /*#__PURE__*/ _createElementVNode("path", {
            id: "path17",
            d: "m 0,0 c -3.539,5.468 -9.662,9.112 -16.645,9.112 -7.015,0 -13.158,-3.682 -16.689,-9.193 -1.976,-3.086 -3.159,-6.728 -3.159,-10.657 0,-3.927 1.183,-7.57 3.159,-10.655 3.531,-5.51 9.674,-9.193 16.689,-9.193 6.983,0 13.106,3.645 16.645,9.112 2.007,3.101 3.203,6.776 3.203,10.736 C 3.203,-6.776 2.007,-3.101 0,0",
            style: { "fill-opacity": "1", "fill-rule": "nonzero", "stroke": "none" },
            transform: "matrix(0.35277776,0,0,-0.35277776,63.267456,49.129973)",
            "clip-path": "url(#clipPath18)"
        })
    ])
], -1));
const _hoisted_7 = { key: 1 };
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "text-header text-base leading-none px-2.5 logo-text" }, " Hit-Online ", -1));
const _hoisted_9 = [
    _hoisted_8
];
const _hoisted_10 = { class: "header-language-selector" };
const _hoisted_11 = { class: "language-selected" };
const _hoisted_12 = { class: "language-flag" };
const _hoisted_13 = { class: "language-name" };
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("path", {
    d: "M6 9L12 15L18 9",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
}, null, -1));
const _hoisted_15 = [
    _hoisted_14
];
const _hoisted_16 = {
    key: 0,
    class: "language-options"
};
const _hoisted_17 = ["onClick"];
const _hoisted_18 = { class: "language-flag" };
const _hoisted_19 = { class: "language-name" };
const _hoisted_20 = { id: "hit-header-bottom" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_sodipodi58namedview = _resolveComponent("sodipodi:namedview");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", {
                class: "px-2 header cursor-pointer flex flex-row items-center bg-transparent",
                onClick: _cache[0] || (_cache[0] =
                    //@ts-ignore
                    (...args) => (_ctx.navigateHome && _ctx.navigateHome(...args)))
            }, [
                (_ctx.responsiveBreakpointMd)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        (_openBlock(), _createElementBlock("svg", _hoisted_4, [
                            _createVNode(_component_sodipodi58namedview, {
                                id: "namedview1",
                                pagecolor: "#ffffff",
                                borderopacity: "0.25",
                                "inkscape:showpageshadow": "2",
                                "inkscape:pageopacity": "0.0",
                                "inkscape:pagecheckerboard": "true",
                                "inkscape:deskcolor": "#d1d1d1",
                                "inkscape:document-units": "mm",
                                "inkscape:zoom": "2.7185938",
                                "inkscape:cx": "79.820678",
                                "inkscape:cy": "91.591469",
                                "inkscape:window-width": "3440",
                                "inkscape:window-height": "1403",
                                "inkscape:window-x": "0",
                                "inkscape:window-y": "0",
                                "inkscape:window-maximized": "1",
                                "inkscape:current-layer": "layer1",
                                showgrid: "false"
                            }),
                            _hoisted_5,
                            _hoisted_6
                        ]))
                    ]))
                    : _createCommentVNode("", true),
                (_ctx.responsiveBreakpointMd)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
                    : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", {
                    class: "language-dropdown-container",
                    onClick: _cache[1] || (_cache[1] =
                        //@ts-ignore
                        (...args) => (_ctx.toggleLanguageDropdown && _ctx.toggleLanguageDropdown(...args)))
                }, [
                    _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.getCurrentLanguageFlag()), 1),
                        _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.getCurrentLanguageName()), 1),
                        (_openBlock(), _createElementBlock("svg", {
                            class: _normalizeClass(["dropdown-icon", { rotated: _ctx.showLanguageDropdown }]),
                            width: "16",
                            height: "16",
                            viewBox: "0 0 24 24",
                            fill: "none"
                        }, _hoisted_15, 2))
                    ]),
                    (_ctx.showLanguageDropdown)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableLanguages, (lang) => {
                                return (_openBlock(), _createElementBlock("div", {
                                    key: lang.code,
                                    class: _normalizeClass(["language-option", { active: _ctx.$i18n.locale === lang.code }]),
                                    onClick: _withModifiers(($event) => (_ctx.selectLanguage(lang.code)), ["stop"])
                                }, [
                                    _createElementVNode("span", _hoisted_18, _toDisplayString(lang.flag), 1),
                                    _createElementVNode("span", _hoisted_19, _toDisplayString(lang.name), 1)
                                ], 10, _hoisted_17));
                            }), 128))
                        ]))
                        : _createCommentVNode("", true)
                ])
            ])
        ]),
        _createElementVNode("div", _hoisted_20, [
            _renderSlot(_ctx.$slots, "bottom", {}, undefined, true)
        ])
    ]));
}
